import React from "react";
import { observer } from "mobx-react";
import { SatelliteTaskViewStore } from "../../store";
import { SatelliteTaskViewForm } from "./SatelliteTaskViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SatelliteTaskViewProps = {
  satelliteTaskViewStore: SatelliteTaskViewStore;
};

export const SatelliteTaskView: React.FC<SatelliteTaskViewProps> = observer(
  ({ satelliteTaskViewStore }) => {
    return (
      <div>
        <SatelliteTaskViewForm
          taskType={satelliteTaskViewStore.taskTypeValue}
          status={satelliteTaskViewStore.statusValue}
          priority={satelliteTaskViewStore.priorityValue}
          input={satelliteTaskViewStore.inputValue}
          output={satelliteTaskViewStore.outputValue}
          error={satelliteTaskViewStore.errorValue}
          correlationId={satelliteTaskViewStore.correlationIdValue}
          timeoutMs={satelliteTaskViewStore.timeoutMsValue}
          retryCount={satelliteTaskViewStore.retryCountValue}
          maxRetries={satelliteTaskViewStore.maxRetriesValue}
          queuedAt={satelliteTaskViewStore.queuedAtValue}
          sentAt={satelliteTaskViewStore.sentAtValue}
          startedAt={satelliteTaskViewStore.startedAtValue}
          completedAt={satelliteTaskViewStore.completedAtValue}
          duration={satelliteTaskViewStore.durationValue}
          botRunValue={satelliteTaskViewStore.botRunValue}
          onPrint={(handlePrint: () => void) =>
            satelliteTaskViewStore.printSatelliteTask(handlePrint)
          }
          onCancel={() => satelliteTaskViewStore.cancelSatelliteTask()}
          onEdit={
            satelliteTaskViewStore.isEditEnabled
              ? () => satelliteTaskViewStore.editSatelliteTask()
              : undefined
          }
        />
        <ErrorDialog
          open={satelliteTaskViewStore.errorDialogOpened}
          title={satelliteTaskViewStore.errorTitle}
          description={satelliteTaskViewStore.errorDescription}
          onClose={() => satelliteTaskViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
